import { render } from "./header.html?vue&type=template&id=2f0c96d2"
import script from "./header.js?vue&type=script&lang=js"
export * from "./header.js?vue&type=script&lang=js"

import "./header.less?vue&type=style&index=0&lang=less"

import exportComponent from "/Users/vito.degioia/Documents/Projects/mb-fiori-2023/fiori-del-mulino/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__